import dotenv from "dotenv";
import fs from "fs";
import * as D from "./../imports/index.js";
import type { SolcatcherConfig } from "../config/types.js";

export function loadEnvFromConfig(config: SolcatcherConfig) {
  if (config.autoLoadEnv === false) return;

const envPath =
  config.envPath ??
  process.env.SOLCATCHER_ENV ??   // ✅ scoped
  D.DEFAULT_ENV_PATH;

  if (!envPath) return;
  if (!fs.existsSync(envPath)) return;

  dotenv.config({ path: envPath });
}